/* more markets 展开及数据请求切换 */
// 注意会用到属性 marketId, 注意在引用组件上定义
// import MarketNavs from './index.vue'
import { ref } from '@vue/composition-api'
import useDefaultMarket from '../market/useDefaultMarket'
import { isSpecialMarket } from '@ms/components/match/marketBus.js'

export default function useMoreMarket() {
  const lastMarketId = ref('')
  const marketLoaded = ref(false)

  const { defaultMarkets, marketsMap, marketGroupList, getMarketInfo, getSuperMarketInfo } = useDefaultMarket()

  const isDefaultMarket = (marketId) => {
    return defaultMarkets.value.some(({ id }) => id === marketId)
  }

  // 判断是否需要请求指定 marekt 比赛列表, 返回值：0 不请求，1 请求默认列表，2 请求指定 market 比赛列表
  const shouldFetchMatchesWithMarket = (marketId) => {
    // 如果当前 marketId 是默认类型的 market，如果 lastMarketId 也是默认类型，则不需要请求，否则请求默认比赛列表
    if (isDefaultMarket(marketId)) {
      if (isDefaultMarket(lastMarketId.value)) {
        // 0 不请求
        return 0
      } else {
        // 1 请求默认列表
        return 1
      }
    } else {
      // 2 请求指定 market 比赛列表
      return 2
    }
  }

  const checkHasMoreMarkets = (sportId) => {
    // soccer && esport soccer
    return sportId === 'sr:sport:1' || sportId === 'sr:sport:137'
  }

  const resetLastMarketId = () => {
    lastMarketId.value = ''
  }

  // 获取默认 marekt with others + special markets
  const fetchAllMarkets = async (sportId) => {
    marketLoaded.value = false
    await Promise.all([getMarketInfo({ sportId, withOthers: true }), getSuperMarketInfo(sportId)])
    marketLoaded.value = true
  }

  return {
    lastMarketId,
    marketLoaded,
    defaultMarkets,
    marketsMap,
    marketGroupList,
    getMarketInfo,
    isSpecialMarket,
    isDefaultMarket,
    shouldFetchMatchesWithMarket,
    checkHasMoreMarkets,
    resetLastMarketId,
    fetchAllMarkets
  }
}
